import { lazy } from 'react';

// project imports
import GuestGuard from 'components/auth/GuestGuard';
import Loadable from 'components/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const JoinPage = Loadable(lazy(() => import('pages/auth/Join')));
const MagicLinkPage = Loadable(lazy(() => import('pages/auth/MagicLink')));
const ForgotPasswordPage = Loadable(lazy(() => import('pages/auth/ForgotPassword')));
const ResetPasswordPage = Loadable(lazy(() => import('pages/auth/ResetPassword')));
const StatusPage = Loadable(lazy(() => import('pages/status')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          )
        },
        {
          path: '/register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          )
        },
        {
          path: '/join/:inviteToken',
          element: <JoinPage />
        },
        {
          path: '/login/magic-link',
          element: (
            <GuestGuard>
              <MagicLinkPage />
            </GuestGuard>
          )
        },
        {
          path: '/forgot-password',
          element: (
            <GuestGuard>
              <ForgotPasswordPage />
            </GuestGuard>
          )
        },
        {
          path: '/reset-password',
          element: (
            <GuestGuard>
              <ResetPasswordPage />
            </GuestGuard>
          )
        },
        {
          path: '/status',
          element: <StatusPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
